import clsx from 'clsx';

import { ReactComponent as InfoFilledIcon } from 'component-lib/atoms/icon/InfoFilledIcon.svg';
import { Tooltip } from 'component-lib/atoms/tooltip/Tooltip';

export const InfoIcon = ({ children, className, ...rest }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span className={clsx('inline-flex items-center align-middle cursor-default', className)} aria-hidden {...rest}>
    <Tooltip content={children}>
      <InfoFilledIcon className="text-secondary" />
    </Tooltip>
  </span>
);
